import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { SiteProvider } from './data/SiteContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import { DestinationsList, DestinationDetail } from './pages/Destinations';
import { HotelsList, HotelDetail } from './pages/Hotels';
import Tours, { TourDetail } from './pages/Tours';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import { RegionsList, RegionCountries, CountryDetail } from './pages/Regions';
import Cruises, { CruiseDetail } from './pages/Cruises';
import Experiences, { ExperienceDetail } from './pages/Experiences';
import { GuidesHub, GuideDetail } from './pages/Guides';
import TravelInfo from './pages/TravelInfo';
import Concierge from './pages/Concierge';
import Partners from './pages/Partners';
import About from './pages/About';
import AdminApp from './pages/admin/AdminApp';
import AdminLogin from './pages/admin/Login';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div style={{ minHeight:'100vh' }}>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/destinations" element={<DestinationsList />} />
            <Route path="/destinations/:id" element={<DestinationDetail />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/tours/:id" element={<TourDetail />} />
            <Route path="/hotels" element={<HotelsList />} />
            <Route path="/hotels/:id" element={<HotelDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/regions" element={<RegionsList />} />
            <Route path="/regions/:regionKey" element={<RegionCountries />} />
            <Route path="/regions/:regionKey/:countryKey" element={<CountryDetail />} />
            <Route path="/cruises" element={<Cruises />} />
            <Route path="/cruises/:id" element={<CruiseDetail />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/experiences/:key" element={<ExperienceDetail />} />
            <Route path="/guides" element={<GuidesHub />} />
            <Route path="/guides/:key" element={<GuideDetail />} />
            <Route path="/travel-info" element={<TravelInfo />} />
            <Route path="/concierge" element={<Concierge />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
